import { Box } from "@mui/material";

type ProfileActionIconProps = {
  src: string;
};

/**
 * Paints a static SVG through a mask so it takes the button's text colour,
 * which an <img> cannot do.
 */
const ProfileActionIcon = ({ src }: ProfileActionIconProps) => {
  const mask = `url(${src}) center / contain no-repeat`;

  return (
    <Box
      component="span"
      aria-hidden
      className="profile-card-start-icon"
      sx={{
        display: "inline-block",
        width: 18,
        height: 18,
        backgroundColor: "currentColor",
        mask,
        WebkitMask: mask,
      }}
    />
  );
};

export default ProfileActionIcon;
